<template>
  <v-dialog
    v-model="dialog"
    max-width="40rem"
    :fullscreen="$vuetify.breakpoint.xsOnly"
    scrollable
  >
    <template v-slot:activator="{ on: dialog }">
      <v-btn v-on="{ ...dialog }">
        <v-icon small left>fa-calculator</v-icon>
        Calcul du pourboire
      </v-btn>
    </template>
    <v-card>
      <v-card-title class="px-1 pt-1">
        <v-row justify="end" no-gutters>
          <v-btn small icon text @click="dialog = false">
            <v-icon small>fa-times</v-icon>
          </v-btn>
        </v-row>
      </v-card-title>
      <v-card-text>
        <RangeDatePicker
          filled
          no-before
          label="Période à calculer"
          :loading="loading"
          v-model="period"
        ></RangeDatePicker>
        <v-row align="center">
          <v-col cols="12" sm="6">
            <v-text-field
              :value="getTipsTotal"
              readonly
              filled
              class="no-before"
              hide-details
              suffix="$"
              label="Total des pourboires"
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="6">
            <j-decimal-input
              v-model="hours"
              filled
              no-before
              class="no-before"
              hide-details
              label="Total des heures travaillées"
            ></j-decimal-input>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <v-text-field
              :value="getValueByHour"
              background-color="success"
              dark
              readonly
              filled
              class="no-before"
              hide-details
              prefix="="
              suffix="$"
              label="Pourboire par heure travaillée"
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row no-gutters v-show="loading">
          <v-progress-linear indeterminate></v-progress-linear>
        </v-row>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import { round10 } from "round10";
import { api } from "@/api";
import { RangeDatePicker } from "@/modules/Shared";
export default {
  name: "TillTipsCalculator",
  components: {
    RangeDatePicker
  },
  computed: {
    getTipsTotal() {
      return this.tips
        .map(x =>
          round10(Number(x.cash) + Number(x.tpv) + Number(x.others), -2)
        )
        .reduce((a, b) => a + b, 0);
    },
    getValueByHour() {
      if (this.hours > 0) {
        return round10(this.getTipsTotal / this.hours, -2);
      } else {
        return 0;
      }
    }
  },
  data() {
    return {
      loading: false,
      dialog: false,
      period: [],
      tips: [],
      hours: 0
    };
  },
  methods: {
    async getData() {
      try {
        this.loading = true;
        if (this.period.length >= 2) {
          this.tips = await api.getTips({
            start: this.period[0],
            end: this.period[1]
          });
        }
      } finally {
        this.loading = false;
      }
    }
  },
  watch: {
    period: {
      deep: true,
      handler: "getData"
    },
    dialog(v) {
      if (v === false) {
        this.tips = [];
        this.period = [];
        this.hours = 0;
      }
    }
  }
};
</script>

<style></style>
